import { IntegrationClient } from '../types';

export interface Integration {
  clients: IntegrationClient[];
}

export class Integration implements Integration {}
